/**
 * Reduced-motion helpers (A11Y-4).
 *
 * Pure, cross-platform building blocks for honoring the user's "reduce motion"
 * preference. The web side reads `prefers-reduced-motion`; native callers use
 * `AccessibilityInfo` directly in the hook (`useReducedMotion`).
 */

/** CSS media query that signals the OS-level "reduce motion" preference on web. */
export const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Read the current `prefers-reduced-motion` value on web.
 * Returns `false` when `window`/`matchMedia` is unavailable (SSR, native, old
 * browsers) so callers default to the full (animated) experience.
 */
export const getWebReducedMotionInitial = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  try {
    return window.matchMedia(REDUCED_MOTION_MEDIA_QUERY).matches;
  } catch {
    return false;
  }
};
